'use client';

import { useEffect, useState } from 'react';

// True until the first page has mounted in this tab. Module state, so it
// survives across navigations and resets only on a full load.
let firstMount = true;

/**
 * Wraps every page. A template remounts on each client-side navigation, which
 * is exactly the moment the new page should ease in. The first page of a visit
 * is deliberately left alone: it should paint as fast as it can, and a fade on
 * arrival would push the largest paint back for nothing.
 *
 * The easing is a CSS animation that always ends at full opacity, so a bundle
 * that stalls mid-flight still leaves the page readable. Reduced motion turns
 * it off (see globals.css).
 */
export default function Template({ children }: { children: React.ReactNode }) {
  // Read in the initialiser, written in an effect: React may call an
  // initialiser twice, so it must not change anything it then reads.
  const [entering] = useState(() => typeof window !== 'undefined' && !firstMount);
  useEffect(() => {
    firstMount = false;
  }, []);
  return <div className={entering ? 'page-enter' : undefined}>{children}</div>;
}
